import { useTranslation } from "react-i18next";
import { SwalAlertClass } from "core/swalClass";
import { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
// -
import { compareObjects } from "core/utils/objectUtils";
import useCustomTranslation from "core/customTranslation";
import translations from "./translations";

const MiniQValuesModel = {
    power: 20,
    vacuum: 25,
    filling: 75,
}
const MiniQHasModel = {
    vacuum: true,
    filling: true,
}

const MiniQForm = ({ item }) => {
    const { t } = useTranslation("forms");
    const { t: tC } = useCustomTranslation(translations);
    const Alert = new SwalAlertClass({ confirmButtonText: tC("accept") });
    const [values, setValues] = useState({ ...MiniQValuesModel });
    const [has, setHas] = useState({ ...MiniQHasModel });
    const styleCenterMiddle = { textAlign: "center", verticalAlign: "middle" };

    useEffect(() => {
        if (item.id) {
            if (compareObjects(item.values, MiniQValuesModel)) {
                setValues({ ...item.values });
                setHas({ ...item.has });
            } else {
                setValues({ ...MiniQValuesModel });
                setHas({ ...MiniQHasModel });
            }
        } else {
            setValues({ ...MiniQValuesModel });
            setHas({ ...MiniQHasModel });
        }
    }, [item]);


    const onChangeValues = (e) => {
        let { name, value } = e.target;
        let values_ = { ...values };
        values_[name] = value;
        setValues({ ...values_ });
    }


    const onChangeCheckHas = (e) => {
        let { name, checked } = e.target;
        name = name.replace("has-", "");
        let has_ = { ...has };
        has_[name] = checked;
        setHas({ ...has_ });
    }

    const onBlurValues = (e) => {
        const { title, name } = e.target;
        let value = parseInt(e.target.value)
        let min = parseInt(e.target.min)
        let max = parseInt(e.target.max)
        if (value < min || max < value) {
            Alert.warning(
                title,
                tC("value.range").replace("{min}", min).replace("{max}", max)
            )
            let values_ = { ...values };
            values_[name] = e.target.dataset.default;
            setValues({ ...values_ });
            e.target.focus();
        }
    }

    return <>
        <div className="col-md-3 col-12">
            <label htmlFor="type">{tC("type")}</label>
            <Form.Select
                className="mb-2"
                id="type" name="type"
                defaultValue="s"
                style={{ width: "120px" }}
            >
                <option value="s">{tC("single")}</option>
            </Form.Select>
        </div>
        <div className="row">
            <div className="col-12">
                <table className="table table-striped mb-5">
                    <thead>
                        <tr>
                            <th>{t("common.name")}</th>
                            <th>{t("common.description")}</th>
                            <th className="text-center">{tC("parameters")}</th>
                            <th style={{ width: "35px", textAlign: "center" }}>{tC("active")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{tC("power")}</td>
                            <td>{tC("power.description")}</td>
                            <td>
                                <div className="row">
                                    <div className="col-md-8">
                                        <div className="text-md-end mt-2">
                                            <label htmlFor="days" className="form-label">%</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4 d-flex align-items-center">
                                        <input
                                            type="number"
                                            id="power"
                                            name="power"
                                            className="mb-2 form-control text-end"
                                            required={true}
                                            min="1" max="100" step="1"
                                            title={tC("power")}
                                            data-default="20"
                                            value={values.power}
                                            onChange={onChangeValues}
                                            onBlur={onBlurValues}
                                        />
                                    </div>
                                </div>
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>{tC("vacuum")}</td>
                            <td>{tC("vacuum.description")}</td>
                            <td>
                                <div className="row">
                                    <div className="col-md-8">
                                        <div className="text-md-end mt-2">
                                            <label htmlFor="days" className="form-label">{tC("percentage")}</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4 d-flex align-items-center">
                                        <input
                                            type="number"
                                            id="vacuum"
                                            name="vacuum"
                                            className="mb-2 form-control text-end"
                                            required={true}
                                            min="0" max="100" step="1"
                                            title={tC("vacuum")}
                                            data-default="25"
                                            value={values.vacuum}
                                            onChange={onChangeValues}
                                            onBlur={onBlurValues}
                                        />
                                    </div>
                                </div>
                            </td>
                            <td style={styleCenterMiddle}>
                                <div className="form-switch">
                                    <input
                                        name="has-vacuum"
                                        type="checkbox"
                                        id="has-vacuum"
                                        className="form-check-input"
                                        checked={has.vacuum}
                                        onChange={onChangeCheckHas}
                                    />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>{tC("filling")}</td>
                            <td>{tC("filling.description")}</td>
                            <td>
                                <div className="row">
                                    <div className="col-md-8">
                                        <div className="text-md-end mt-2">
                                            <label htmlFor="days" className="form-label">{tC("percentage")}</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4 d-flex align-items-center">
                                        <input
                                            type="number"
                                            id="filling"
                                            name="filling"
                                            className="mb-2 form-control text-end"
                                            required={true}
                                            min="0" max="100" step="1"
                                            title={tC("filling")}
                                            data-default="75"
                                            value={values.filling}
                                            onChange={onChangeValues}
                                            onBlur={onBlurValues}
                                        />
                                    </div>
                                </div>
                            </td>
                            <td style={styleCenterMiddle}>
                                <div className="form-switch">
                                    <input
                                        name="has-filling"
                                        type="checkbox"
                                        id="has-filling"
                                        className="form-check-input"
                                        checked={has.filling}
                                        onChange={onChangeCheckHas}
                                    />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </>
}
export default MiniQForm;